module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-charge"
  }, [_c('h2', [_vm._v(_vm._s(_vm.contract_id ? '' : '空房') + "乐住智能电表充值")]), _c('div', {
    staticClass: "ui two columns stackable grid form"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui button orange",
    on: {
      "click": function($event) {
        _vm.form.fee = 100
      }
    }
  }, [_vm._v("电100元")]), _c('div', {
    staticClass: "ui button yellow",
    on: {
      "click": function($event) {
        _vm.form.fee = 50
      }
    }
  }, [_vm._v("电50元")])]), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("电表编号")]), _c('el-input', {
    attrs: {
      "allow-dot": false,
      "disabled": "disabled"
    },
    model: {
      value: (_vm.form.meter_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "meter_id", $$v)
      },
      expression: "form.meter_id"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("电费 / 元")]), _c('compare-input', {
    attrs: {
      "min": 0,
      "allow-dot": true
    },
    model: {
      value: (_vm.form.fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "fee", $$v)
      },
      expression: "form.fee"
    }
  })], 1)]), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("支付方式")]), _c('payment-method-select', {
    model: {
      value: (_vm.form.payment_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "payment_method", $$v)
      },
      expression: "form.payment_method"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("备注")]), _c('el-input', {
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)])]), _c('div', {
    staticClass: "column"
  }, [_c('receipts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receipts && _vm.receipts.length),
      expression: "receipts && receipts.length"
    }],
    staticClass: "ui segment",
    attrs: {
      "receipts": _vm.receipts
    }
  })], 1), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed icon labeled",
    class: {
      disabled: !_vm.submitable
    },
    on: {
      "click": function($event) {
        _vm.finish()
      }
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("充值")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dc06604","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormChargeLezhu.vue
// module id = 382
// module chunks = 0